module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.29831/images/wizard-person.svg"